import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileForm, ProfileFormProps } from '../shared/profileForm';
import { useStore } from '../../../../hooks/useStore';
import { FormListSelect } from '../../../../lib/components/compound/forms/form/fields/listSelect';
import { useOptions } from '../../../receipts/detailView/shared/useOptions';

type Props = Omit<ProfileFormProps, 'children'>;

export const GroupDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();

  const groups = useOptions(
    {
      getItems: {
        async: async () => {
          await companyStore.fetchGroups();
          return companyStore.groups ?? [];
        }
      },
      map: (g) => ({
        value: g.id,
        text: g.name
      })
    },
    [companyStore.company]
  );

  return (
    <ProfileForm {...props}>
      <FormListSelect label={t('company:GROUPS_ASSIGN')} name="groups" options={groups} />
    </ProfileForm>
  );
};
